import React from 'react';
import map from "lodash/map";
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';
import swal from "sweetalert2";
import orderBy from 'lodash/orderBy';

import { editCard } from '../../../../actions/app/mpt/weeks';
import Destinations from '../Destinations';

import './Card.css';

class Card extends React.Component {
    constructor(props) {
        super();
        this.state = {
            lastname: props.card.lastname,
            img: props.card.urlPicture,
        }
    }

    submitEditCard() {
        const { dispatch, week, card } = this.props;
        const { lastname } = this.state;
        dispatch(editCard({ lastname } , week.id, card.id));
    }

    onDrop(acceptedFiles, weekId, cardId) {
        const { dispatch } = this.props;
        this.setState({ img: acceptedFiles[0].preview });
        dispatch(editCard({ file: acceptedFiles[0] }, weekId, cardId))
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.state.app.mpt.weeks.info.error) {
            swal({
                title: `Oops...`,
                type: 'error',
                html: `Something went wrong, error: "${nextProps.state.app.mpt.weeks.info.error}" <br />Try again`
            });
        }
    }

    render() {
        const { card, week, clubs } = this.props;
        const { d0, d1, d2, d3, d4, d5, d6 } = card.destinations;
        const { img, lastname } = this.state;
        const destinations = {
            d0: { id: 'd0', value: d0 },
            d1: { id: 'd1', value: d1 },
            d2: { id: 'd2', value: d2 },
            d3: { id: 'd3', value: d3 },
            d4: { id: 'd4', value: d4 },
            d5: { id: 'd5', value: d5 },
            d6: { id: 'd6', value: d6 },
        };
        return(
            <div className="col-md-12 row card container">
                <div className="col-md-12 -align-center">
                    <div className="col-md-2">
                        <input
                            onChange={(t) => this.setState({ lastname: t.target.value })}
                            onBlur={() => this.submitEditCard()}
                            value={lastname}
                        />
                    </div>
                    <div className="col-md-2">
                        <Dropzone
                            onDrop={(acceptedFiles) =>
                                this.onDrop(acceptedFiles, week.id, card.id)
                            }
                            className="btn-warning dropzone text-center"
                        >
                            Upload
                        </Dropzone>
                    </div>
                    <div className="col-md-2">
                        <img
                            className="playerPicture"
                            src={img}
                            alt=""
                        />
                    </div>
                </div>
                <h3>Destinations :</h3>
                <div className="col-md-12 destinationsContainer">
                    {
                        map(destinations, d => {
                            return (
                                <Destinations
                                    d={d}
                                    key={`destination.${card.id}.${d.id}`}
                                    clubs={orderBy(clubs, ['clubName', 'asc'])}
                                    week={week}
                                    card={card}
                                />
                            );
                        })
                    }
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({ state }),
    dispatch => ({ dispatch }),
)(Card);



// WEBPACK FOOTER //
// ./src/pages/MPT/Creation/Card/index.js